import { render, staticRenderFns } from "./SignatureDetail.vue?vue&type=template&id=18a497eb&scoped=true"
import script from "./SignatureDetail.vue?vue&type=script&lang=js"
export * from "./SignatureDetail.vue?vue&type=script&lang=js"
import style0 from "./SignatureDetail.vue?vue&type=style&index=0&id=18a497eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a497eb",
  null
  
)

export default component.exports